import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Vuelidate from 'vuelidate'

// Import components
import Gallery from "./components/Gallery.vue";
import Attachments from "./components/Attachments.vue";
import Blog from "./components/Blog.vue";
import Newsletter from "./components/Newsletter.vue";

// asxios defaults
axios.defaults.baseURL = window.location.protocol + "//" + window.location.host;

window.Vue = require("vue");

// Vue use
Vue.use(VueAxios, axios);
Vue.use(Vuelidate);

const app = new Vue({
    el: "#app",
    components: {
        Gallery,
        Attachments,
        Blog,
        Newsletter
    }
});